<app-modal
  [title]="mode === 'authorized'
    ? ('Discount authorization' | trans:'cart/discount-authorization-modal/header/title')
    : ('Choose discount percentage' | trans:'cart/discount-percentage-picker-modal/header/title')"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    @if (step() === 'authorization') {
      <div class="d-flex flex-direction-column gap-16">
        <p>
          {{ 'A supervisor must authorize this discount.' | trans:'cart/discount-authorization-modal/instruction.Text' }}
        </p>

        @if (lastLoggedEmployees.length > 0) {
          <div class="d-flex gap-8 flex-wrap">
            @for (employee of lastLoggedEmployees; track employee.email) {
              <app-avatar
                [size]="65"
                [text]="employee.firstName[0] + employee.lastName[0]"
                [selectable]="true"
                [selected]="employee.email === selectedEmployee?.email"
                [email]="employee.email"
                (selectedChange)="selectEmployee(employee)"
              />
            }

            <div
              class="border-radius-100 c-bg-gray-900 d-flex align-items-center justify-content-center c-t-gray-100 cursor-pointer flex-shrink-0"
              style="width: 65px; height: 65px;"
              (click)="startNewEmployee()"
            >
              <i class="ri-add-line"></i>
            </div>
          </div>
        }

        <app-form-control
          label="{{ 'Email' | trans:'cart/discount-authorization-modal/email.Label' }}"
          [class.d-none]="selectedEmployee"
        >
          <input
            type="email"
            [(ngModel)]="email"
            placeholder="{{ 'Enter supervisor email' | trans:'cart/discount-authorization-modal/email.Placeholder' }}"
          >
        </app-form-control>

        <app-form-control
          label="{{ 'PIN' | trans:'cart/discount-authorization-modal/pin.Label' }}"
        >
          <input
            #pinInput
            type="password"
            [(ngModel)]="pin"
            cxNumbersInputOnly
            placeholder="{{ 'Enter supervisor PIN' | trans:'cart/discount-authorization-modal/pin.Placeholder' }}"
          >
        </app-form-control>

        <app-content-box theme="gray">
          <app-keyboard
            [isSimple]="true"
            (deleteBack)="handlePinDeleteBack()"
            (keyClick)="handlePinKeyClick($event)"
          />
        </app-content-box>
      </div>
    } @else {
      <div>
        <app-content-editable-input
          [inputType]="'percentage'"
          (valueChange)="percentageValue = $event"
        />

        @if (mode === 'normal' && range) {
          <div class="d-flex justify-content-flex-end m-t-auto p-t-4">
            <div class="width-fit-content p-4 base-border-radius c-bg-blue-200 p3">
              {{ range.min }}% - {{ range.max }}%
            </div>
          </div>
        }
      </div>

      <div class="m-t-24">
        <app-content-box theme="gray">
          <app-keyboard
            [class.disabled]="isLoading()"
            [isSimple]="false"
            (clear)="handlePercentageClear()"
            (deleteBack)="handlePercentageDeleteBack()"
            (keyClick)="handlePercentageKeyClick($event)"
          />
        </app-content-box>
      </div>
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      @if (step() === 'authorization') {
        <button
          class="button button--md button--primary-ghost text-uppercase"
          (click)="close()"
        >
          {{ 'Cancel' | trans:'cart/discount-authorization-modal/cancel.Button' }}
        </button>
        <button
          class="button button--md button--primary text-uppercase"
          [disabled]="isNextDisabled"
          (click)="goToPercentageStep()"
        >
          {{ 'Next' | trans:'cart/discount-authorization-modal/next.Button' }}
        </button>
      } @else {
        @if (mode === 'authorized') {
          <button
            class="button button--md button--primary-ghost text-uppercase"
            [disabled]="isLoading()"
            (click)="goToAuthorizationStep()"
          >
            {{ 'Back' | trans:'cart/discount-authorization-modal/back.Button' }}
          </button>
        } @else {
          <button
            class="button button--md button--primary-ghost text-uppercase"
            [disabled]="isLoading()"
            (click)="close()"
          >
            {{ 'Cancel' | trans:'cart/discount-percentage-picker-modal/cancel.Button' }}
          </button>
        }
        <button
          class="button button--md button--primary text-uppercase"
          [disabled]="isConfirmDisabled"
          (click)="confirm()"
        >
          {{ 'Confirm' | trans:(mode === 'authorized' ? 'cart/discount-authorization-modal/confirm.Button' : 'cart/discount-percentage-picker-modal/confirm.Button') }}
        </button>
      }
    </div>
  </ng-container>
</app-modal>
